import { defineMessages } from 'react-intl';

export default defineMessages({
  requiredField: {
    id: 'Required field',
    defaultMessage: 'Required field'
  },
  invalidField: {
    id: 'Invalid field',
    defaultMessage: 'Invalid field'
  },
  labelSignUpMContigo: {
    id: 'Sign Up',
    defaultMessage: 'Sign Up'
  },
  labelFullName: {
    id: 'Full name',
    defaultMessage: 'Full name'
  },
  labelEmail: {
    id: 'Email',
    defaultMessage: 'Email'
  },
  labelPassword: {
    id: 'Password',
    defaultMessage: 'Password'
  },
  checkboxLabelAgree: {
    id: 'I accept the {link1} and ours {link2}',
    defaultMessage: 'I accept the {link1} and ours {link2}',
  },
  checkboxLabelTermsAndConditionsCheckbox: {
    id: 'terms and conditions',
    defaultMessage: 'terms and conditions'
  },
  checkboxLabelConsentTerms: {
    id: 'privacy policy.',
    defaultMessage: 'privacy policy.'
  }
});
